/**
 * ContentSage Logo Component
 *
 * Uses the official ContentSage logo (stylized S with gradient and sparkles).
 */

interface ContentSageLogoProps {
  size?: number;
  className?: string;
  showText?: boolean;
  textClassName?: string;
}

export default function ContentSageLogo({
  size = 40,
  className = '',
  showText = true,
  textClassName = '',
}: ContentSageLogoProps) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img
        src="/contentsage-logo-1000x1000.png"
        alt="ContentSage"
        width={size}
        height={size}
        className="rounded-lg"
        style={{ width: size, height: size }}
      />

      {showText && (
        <span className={`text-xl font-bold bg-gradient-to-r from-blue-400 via-purple-500 to-amber-400 bg-clip-text text-transparent ${textClassName}`}>
          ContentSage
        </span>
      )}
    </div>
  );
}

/**
 * Compact logo for header/navigation
 */
export function ContentSageLogoCompact({ className = '' }: { className?: string }) {
  return (
    <ContentSageLogo
      size={36}
      showText={true}
      className={className}
    />
  );
}

/**
 * Full logo with tagline for hero sections
 */
export function ContentSageLogoFull({ className = '' }: { className?: string }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <ContentSageLogo size={50} showText={false} />
      <div className="flex flex-col">
        <span className="text-2xl font-bold bg-gradient-to-r from-blue-400 via-purple-500 to-amber-400 bg-clip-text text-transparent">
          ContentSage
        </span>
        <span className="text-sm text-slate-400 italic">Your SEO Oracle</span>
      </div>
    </div>
  );
}

/**
 * Icon-only logo (no text) for mobile headers
 */
export function ContentSageIcon({ size = 32, className = '' }: { size?: number; className?: string }) {
  return (
    <img
      src="/contentsage-logo-1000x1000.png"
      alt="ContentSage"
      width={size}
      height={size}
      className={`rounded-lg ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
